export interface Voucher {
  _id?: string;
  nanoid?: string;
  merchant?: string;
  title: string;
  displayAs?: string;
  description?: string;
  value: number;
  cost: number;
  expiryDays: number;
  quantityLimit?: number;
  quantitySold?: number;
  active?: boolean;
  allowPartialRedemption?: boolean;
  showValueInDisplay?: boolean;
  terms?: string;
  locations?: string[];
  _canManage?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  discount?: {
    value: number;
    percent: number;
  };
  cover?: any;
  coverImageOptions?: 'UPLOADED_ONLY' | 'UPLOADED_AND_LIBRARY';
  emailArtwork?: any;
  visibility?: ('app' | 'web')[];
  monetaryOptions?: {
    min: number;
    max: number;
    increment: number;
  };
  voucherType?: 'fixed' | 'monetary';
  displayOrder?: number;
}
